exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-codat-errors .c-page-selection-component{float:right;margin-right:20px}.c-codat-errors .c-item-disabled{opacity:.3}", ""]);

// exports
